import type { ReactNode } from 'react';

export function Shell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen text-charcoal">
      <header className="absolute inset-x-0 top-0 z-10 mx-auto flex max-w-7xl items-center justify-end px-5 py-6 md:px-8">
        <a href="/" className="focus-ring rounded-sm font-serif text-3xl font-semibold tracking-[-0.055em] text-warm">UncleHonest</a>
      </header>
      {children}
    </div>
  );
}
